"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResponseBody = exports.RequestBodyFromSurvey = exports.WiFiAccessPoints = exports.makeApiUrl = exports.API_URL = void 0;
const effect_1 = require("effect");
const binary_1 = require("../../binary");
const net_1 = require("../../net");
const Cellular = __importStar(require("../../network/cellular"));
const Survey = __importStar(require("../../network/survey"));
const compound_1 = require("../../unit/compound");
const Google = __importStar(require("../common"));
const NAMESPACE = 'Google.Geolocation.Geolocate';
exports.API_URL = `${Google.BASE_URL}/geolocation/v1/geolocate`;
const makeApiUrl = (key) => `${exports.API_URL}?key=${key}`;
exports.makeApiUrl = makeApiUrl;
const CellularRadioType = effect_1.Schema.Literal('gsm', 'cdma', 'wcdma', 'lte', 'nr').annotations({
    identifier: `${NAMESPACE}.CellularRadioType`,
});
const GsmCellTower = effect_1.Schema.Struct({
    cellId: Cellular.Gsm.CellId,
    locationAreaCode: Cellular.Gsm.LocationAreaCode,
    mobileCountryCode: Cellular.MobileCountryCode,
    mobileNetworkCode: Cellular.MobileNetworkCode,
}).annotations({ identifier: `${NAMESPACE}.GsmCellTower` });
const CdmaCellTower = effect_1.Schema.Struct({
    cellId: Cellular.Cdma.CellId,
    locationAreaCode: Cellular.Cdma.NetworkId,
    mobileNetworkCode: Cellular.Cdma.SystemId,
}).annotations({ identifier: `${NAMESPACE}.CdmaCellTower` });
const WcdmaCellTower = effect_1.Schema.Struct({
    cellId: Cellular.Wcdma.CellId,
    locationAreaCode: Cellular.Wcdma.LocationAreaCode,
    mobileNetworkCode: Cellular.MobileNetworkCode,
}).annotations({ identifier: `${NAMESPACE}.WcdmaCellTower` });
const LteCellTower = effect_1.Schema.Struct({
    cellId: Cellular.Lte.CellId,
    locationAreaCode: Cellular.Lte.TrackingAreaCode,
    mobileNetworkCode: Cellular.MobileNetworkCode,
}).annotations({ identifier: `${NAMESPACE}.LteCellTower` });
const NrCellTower = effect_1.Schema.Struct({
    newRadio: Cellular.Nr.CellId,
    locationAreaCode: Cellular.Nr.TrackingAreaCode,
    mobileCountryCode: Cellular.MobileCountryCode,
    mobileNetworkCode: Cellular.MobileNetworkCode,
}).annotations({ identifier: `${NAMESPACE}.NrCellTower` });
const getCellTower = effect_1.Match.type().pipe(effect_1.Match.when('gsm', () => GsmCellTower), effect_1.Match.when('cdma', () => CdmaCellTower), effect_1.Match.when('wcdma', () => WcdmaCellTower), effect_1.Match.when('lte', () => LteCellTower), effect_1.Match.when('nr', () => NrCellTower), effect_1.Match.exhaustive);
const GsmBodyProperties = effect_1.Schema.Struct({
    radioType: CellularRadioType.pipe(effect_1.Schema.pickLiteral('gsm')),
    homeMobileCountryCode: Cellular.MobileCountryCode,
    homeMobileNetworkCode: Cellular.MobileNetworkCode,
}).annotations({ identifier: `${NAMESPACE}.GsmBodyProperties` });
const CdmaBodyProperties = effect_1.Schema.Struct({
    radioType: CellularRadioType.pipe(effect_1.Schema.pickLiteral('cdma')),
    homeMobileNetworkCode: Cellular.Cdma.SystemId,
}).annotations({ identifier: `${NAMESPACE}.CdmaBodyProperties` });
const WcdmaBodyProperties = effect_1.Schema.Struct({
    radioType: CellularRadioType.pipe(effect_1.Schema.pickLiteral('wcdma')),
    homeMobileCountryCode: Cellular.MobileCountryCode,
    homeMobileNetworkCode: Cellular.MobileNetworkCode,
}).annotations({ identifier: `${NAMESPACE}.WcdmaBodyProperties` });
const LteBodyProperties = effect_1.Schema.Struct({
    radioType: CellularRadioType.pipe(effect_1.Schema.pickLiteral('lte')),
    homeMobileCountryCode: Cellular.MobileCountryCode,
    homeMobileNetworkCode: Cellular.MobileNetworkCode,
}).annotations({ identifier: `${NAMESPACE}.LteBodyProperties` });
const NrBodyProperties = effect_1.Schema.Struct({
    radioType: CellularRadioType.pipe(effect_1.Schema.pickLiteral('nr')),
    homeMobileCountryCode: Cellular.MobileCountryCode,
    homeMobileNetworkCode: Cellular.MobileNetworkCode,
}).annotations({ identifier: `${NAMESPACE}.NrBodyProperties` });
const getBody = effect_1.Match.type().pipe(effect_1.Match.when('gsm', () => GsmBodyProperties), effect_1.Match.when('cdma', () => CdmaBodyProperties), effect_1.Match.when('wcdma', () => WcdmaBodyProperties), effect_1.Match.when('lte', () => LteBodyProperties), effect_1.Match.when('nr', () => NrBodyProperties), effect_1.Match.exhaustive);
const Carrier = effect_1.Schema.NonEmptyString.annotations({
    identifier: `${NAMESPACE}.Carrier`,
    description: 'The carrier name.',
});
const TimingAdvance = effect_1.Schema.Int.pipe(effect_1.Schema.between(0, 63)).annotations({
    identifier: `${NAMESPACE}.TimingAdvance`,
    documentation: 'https://en.wikipedia.org/wiki/Timing_advance',
});
const WiFiAccessPoint = effect_1.Schema.Struct({
    macAddress: net_1.MacAddress,
    signalStrength: compound_1.DecibelMilliwatts.fields.amount.pipe(effect_1.Schema.optionalWith({ exact: true })),
    age: binary_1.Uint32.pipe(effect_1.Schema.optionalWith({ exact: true })),
    channel: binary_1.Uint32.pipe(effect_1.Schema.optionalWith({ exact: true })),
    signalToNoiseRatio: effect_1.Schema.Number.pipe(effect_1.Schema.optionalWith({ exact: true })),
}).annotations({ identifier: `${NAMESPACE}.WiFiAccessPoint` });
exports.WiFiAccessPoints = effect_1.Schema.Array(WiFiAccessPoint)
    .pipe(effect_1.Schema.minItems(2, { message: () => 'Must contain at least 2 elements.' }))
    .annotations({
    identifier: `${NAMESPACE}.WiFiAccessPoints`,
    documentation: 'https://developers.google.com/maps/documentation/geolocation/requests-geolocation#wifi_access_point_object',
});
const BaseRequestBody = effect_1.Schema.Struct({
    carrier: Carrier,
    considerIp: effect_1.Schema.Boolean,
    wifiAccessPoints: exports.WiFiAccessPoints,
})
    .pipe(effect_1.Schema.partialWith({ exact: true }))
    .annotations({
    identifier: `${NAMESPACE}.BaseRequestBody`,
    description: 'A Google Geolocation API request body excluding cellular-interface-specific properties.',
});
const makeRequestBody = (radioType) => getBody(radioType)
    .pipe(effect_1.Schema.extend(BaseRequestBody), effect_1.Schema.partialWith({ exact: true }), effect_1.Schema.extend(effect_1.Schema.Struct({
    cellTowers: effect_1.Schema.Array(getCellTower(radioType).pipe(effect_1.Schema.extend(effect_1.Schema.Struct({
        age: binary_1.Uint32.pipe(effect_1.Schema.optionalWith({ exact: true })),
        signalStrength: compound_1.DecibelMilliwatts.fields.amount.pipe(effect_1.Schema.optionalWith({ exact: true })),
        timingAdvance: TimingAdvance.pipe(effect_1.Schema.optionalWith({ exact: true })),
    })))),
})))
    .annotations({ identifier: `${NAMESPACE}.makeRequestBody<${radioType}>` });
const RequestBody = effect_1.Schema.Union(BaseRequestBody, ...CellularRadioType.literals.map(makeRequestBody)).annotations({
    identifier: `${NAMESPACE}.RequestBody`,
    documentation: 'https://developers.google.com/maps/documentation/geolocation/requests-geolocation#body',
});
exports.RequestBodyFromSurvey = effect_1.Schema.transformOrFail(Survey.Survey, RequestBody, {
    strict: true,
    decode: survey => effect_1.Effect.succeed(effect_1.Match.value(survey).pipe(effect_1.Match.withReturnType(), effect_1.Match.when({ technology: 'WI-FI' }, ({ data: accessPoints }) => ({
        wifiAccessPoints: accessPoints.map(({ bssid, channel, rssi }) => ({
            macAddress: bssid,
            channel,
            signalStrength: rssi,
        })),
    })), effect_1.Match.exhaustive)),
    encode: (actual, _, ast) => effect_1.Effect.fail(new effect_1.ParseResult.Forbidden(ast, actual, 'Will not encode RequestBody')),
}).annotations({ identifier: `${NAMESPACE}.RequestBodyFromSurvey` });
exports.ResponseBody = effect_1.Schema.Struct({
    location: Google.LatLng,
    accuracy: effect_1.Schema.NonNegative,
}).annotations({
    identifier: `${NAMESPACE}.ResponseBody`,
    documentation: 'https://developers.google.com/maps/documentation/geolocation/requests-geolocation#responses',
});
//# sourceMappingURL=geolocate.js.map